import { motion } from 'framer-motion';
import { FaGraduationCap, FaFileAlt } from 'react-icons/fa';
import { education } from '../../data/education';
import BlurFade from '../ui/BlurFade';

const Education = () => {
  return (
    <section id="education" className="bg-black py-20 text-white">
      <div className="mx-auto max-w-4xl px-6">
        <BlurFade>
          <h2 className="mb-10 text-2xl font-black sm:text-3xl">
            My <span className="text-white/40">Education</span>
          </h2>
        </BlurFade>

        <div className="grid grid-cols-1 items-stretch gap-4 sm:grid-cols-2">
          {education.map((edu, i) => (
            <motion.div
              key={edu.school}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              whileHover={{ y: -4, boxShadow: '0 8px 0 0 rgba(255,255,255,1)' }}
              transition={{ duration: 0.4, delay: (i % 4) * 0.05 }}
              className="flex h-full flex-col rounded-xl border-2 border-white bg-black p-5"
            >
              <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-1">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border-2 border-white">
                    <FaGraduationCap size={14} />
                  </span>
                  <div>
                    <h3 className="font-black">{edu.school}</h3>
                    <p className="text-sm text-white/60">{edu.degree}</p>
                  </div>
                </div>
                <span className="text-xs font-semibold text-white/50">{edu.start} – {edu.end}</span>
              </div>
              <p className="mt-3 flex-1 text-sm text-white/70">
                {edu.grade ? `Grade: ${edu.grade}` : '—'}
              </p>
              {edu.certificateUrl && (
                <a
                  href={edu.certificateUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2 flex w-fit items-center gap-1.5 text-xs font-semibold text-white/60 hover:text-white"
                >
                  <FaFileAlt size={11} /> View certificate
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
